import React from 'react';
import { Text } from '@tamagui/core';
import { XStack, YStack } from '@tamagui/stacks';
import { BadgeCheck, Calendar as CalendarIcon } from 'lucide-react-native';
import { COLORS } from '@/constants/colors';
import type { Profile } from './types';
import InfoButton from './InfoButton';
import {
  PROFILE_NAME_FONT_SIZE,
  PROFILE_TAGLINE_FONT_SIZE,
  PROFILE_DETAIL_FONT_SIZE,
  PROFILE_PRICE_FONT_SIZE,
  BADGE_CHECK_SIZE,
  CALENDAR_ICON_SIZE,
  BADGE_SPACING,
} from './constants';

type ProfileInfoProps = {
  profile: Profile;
  onInfoPress?: () => void;
};

const ProfileInfo = React.memo<ProfileInfoProps>(({ profile, onInfoPress }) => {
  return (
    <YStack position="absolute" left={0} right={0} bottom={0} zIndex={100}>
      {/* Zobacz więcej button - above info panel */}
      <XStack justifyContent="flex-end" paddingHorizontal={BADGE_SPACING} paddingBottom={10} zIndex={101}>
        <InfoButton onPress={onInfoPress} label="Zobacz więcej" />
      </XStack>

      <YStack backgroundColor={COLORS.WHITE_80}>
        <YStack padding="$4" gap="$2">
          <XStack alignItems="center" gap="$2">
            <Text fontSize={PROFILE_NAME_FONT_SIZE} fontWeight="700" color={COLORS.BLACK}>
              {profile.name}, {profile.age}
            </Text>
            {profile.verified ? (
              <BadgeCheck size={BADGE_CHECK_SIZE} color={COLORS.WHITE} fill={COLORS.SUCCESS} />
            ) : null}
          </XStack>

          {profile.tagline ? (
            <Text color={COLORS.BLACK} opacity={1} fontSize={PROFILE_TAGLINE_FONT_SIZE}>
              {profile.tagline}
            </Text>
          ) : null}

          <XStack alignItems="center" justifyContent="space-between" marginTop="$2">
            <XStack alignItems="center" gap="$2">
              <CalendarIcon size={CALENDAR_ICON_SIZE} color={COLORS.BLACK} />
              <Text color={COLORS.BLACK} fontSize={PROFILE_DETAIL_FONT_SIZE}>
                {profile.dateLabel}
              </Text>
            </XStack>
            <Text fontWeight="700" color={COLORS.ZINC_900} fontSize={PROFILE_PRICE_FONT_SIZE}>
              {profile.priceLabel}
            </Text>
          </XStack>
        </YStack>
      </YStack>
    </YStack>
  );
});

ProfileInfo.displayName = 'ProfileInfo';

export default ProfileInfo;
